<template>
    <div v-if="employeeData" class="audit-employee-cell">
        <img 
            v-if="avatarUrl" 
            class="employee-avatar" 
            :src="avatarUrl" 
            :alt="employeeData.name"
        />
        <div v-else class="employee-avatar none"></div>
        <div class="employee-name">{{ employeeData.name }}</div>
    </div>
    <span v-else>-</span>
</template>

<script>
export default {
    name: 'AuditEmployeeCell',
    props: {
        employeeData: {
            type: Object,
            default: null
        }
    },
    computed: {
        avatarUrl() {
            if (!this.employeeData || !this.employeeData.avatar) {
                return null
            }
            
            const avatar = this.employeeData.avatar
            
            // Validar que avatar sea string antes de usar includes
            if (typeof avatar !== 'string') {
                return null
            }
            
            // Si es URL completa (http/https)
            if (avatar.includes('http')) {
                return avatar
            }
            
            // Si es archivo local
            if (avatar.includes('file')) {
                return avatar
            }
            
            // Avatar por defecto desde servidor
            return css_image_url + 'avatar/' + avatar
        }
    }
}
</script>

<style lang="scss" scoped>
.audit-employee-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    
    .employee-avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
        flex-shrink: 0;
        
        &.none {
            background-color: $color-neutral-200;
            border-radius: 50%;
        }
    }
    
    .employee-name {
        font-size: 14px;
        color: $color-black;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>

